import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Header from "./header";
import NewHeader from './NewHeader';
import Bottomnav from "./Bottomnav";
import MenuRoutes from "../../router/dashboardroutes";
import swal from "sweetalert";
import ChatWindow from '../Chat/ChatWindow';
import Home from '../Homepage';
import Services from "../../api/api";
import {
  withRouter
} from "react-router-dom";
import { connect } from "react-redux";
import { gaLogEvent } from "../../helpers/analytics";
import IdleTimer from 'react-idle-timer';
import OffileDb from '../../config/pouchDB';
import {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
} from "../../redux/actions/appActions";
import { auth } from "../../service/firebase";
import { withTranslation, Trans } from "react-i18next";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aMenuRoutes: [],
      isLoading: false,
      timeout:1000 * 900 * 1,
      userLoggedIn: false,
      isTimedOut: false
    };
    this.getcomponetColor = this.getcomponetColor.bind(this);
    this.notificationRedirect = this.notificationRedirect.bind(this);
    this.notificationRedirectPeerchat = this.notificationRedirectPeerchat.bind(this);
    this.checkBackgroundNotifi = this.checkBackgroundNotifi.bind(this);
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    
  }

  componentDidMount() {
    this.triggerNotiBackButton()
    this.onDeviceResume()
    gaLogEvent('Home', '', '');

    let aMenuRoutes = MenuRoutes.map((prop, key) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} name={prop.name} to={prop.to} key={key} />;
      }
      return (
        <Route path={prop.path} name={prop.name} render={() => <prop.component />} key={key} />
      );
    });
    this.setState({ aMenuRoutes: aMenuRoutes })
    var self = this;
    if (window.cordova) {
      self.triggerDeviceBackButton();
      setTimeout(function () {
        self.checkBackgroundNotifi()
      }, 4000);
      // setTimeout(function () {
      //   var myNotiRedPage = localStorage.getItem('notiRedPage');
      //   if (myNotiRedPage) {
      //     myNotiRedPage = JSON.parse(myNotiRedPage);
      //     console.log("myNotiRedPage::", myNotiRedPage.page);
      //     if (myNotiRedPage.page == '/layout/chatwindow' || myNotiRedPage.page == '/layout/adminchat') {
      //       if (window.location.hash != "#/layout/peerchat") {
      //         self.getcomponetColor('peerchat')
      //         self.setActiveTab(myNotiRedPage)
      //         //self.props.history.push("/layout/peerchat");
      //         self.notificationRedirectPeerchat(myNotiRedPage)
      //       }
      //     } else {
      //       if (!window.location.hash.includes(myNotiRedPage.page)) {
      //         self.getcomponetColor(myNotiRedPage.page)
      //         self.setActiveTab(myNotiRedPage)
      //         self.notificationRedirect(myNotiRedPage)

      //       }
      //     }
      //     localStorage.removeItem('notiRedPage')
      //   }
      //   self.triggerDeviceBackButton();
      // }, 4000);
    }

  }


  _onAction(e) {
    console.log('user did something', e)
    this.setState({isTimedOut: false})
  }
 
  _onActive(e) {
    console.log('user is active', e)
    this.setState({isTimedOut: false})
  }

  _onIdle(e) {
    const { t } = this.props;
    console.log('user is idle', e)
    this.setState({isTimedOut: true})
    this.handleLogout()
    swal({
      text: t("Session timed out. Please re-login"),
      icon: "warning",
      buttons: {
        confirm: {
          text: t("Ok"),
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }
    }).then((val) => {
      console.log(val)
      //this.idleTimer.reset();

    });
  }

  handleLogout() {
    this.setState({isTimedOut: false})
    OffileDb.deleteDatabse();
    setTimeout(function () {
      localStorage.removeItem('adminobj')
      localStorage.setItem('obj', localStorage.getItem('tempuserobj'))
      //self.getUserDeatils(JSON.parse(localStorage.getItem("tempuserobj")).userId)
      localStorage.removeItem('tempuserobj')
      
    }, 500);
    this.props.history.push('/layout/LoginPin')
  }

  onDeviceResume() {
    var that = this;
    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        document.addEventListener("resume", function () {
          that.checkBackgroundNotifi()
        }, false);
      })
    }
  }

  checkBackgroundNotifi() {
    var self = this;
    var myNotiRedPage = localStorage.getItem('notiRedPage');
    if (myNotiRedPage) {
      myNotiRedPage = JSON.parse(myNotiRedPage);
      console.log("myNotiRedPage::", myNotiRedPage.page);
      if (myNotiRedPage.page == '/layout/chatwindow' || myNotiRedPage.page == '/layout/adminchat') {
        if (window.location.hash != "#/layout/peerchat") {
          self.getcomponetColor('peerchat')
          self.setActiveTab(myNotiRedPage)
          self.notificationRedirectPeerchat(myNotiRedPage)
        }
      } else {
        if (!window.location.hash.includes(myNotiRedPage.page)) {
          self.getcomponetColor(myNotiRedPage.page)
          self.setActiveTab(myNotiRedPage)
          self.notificationRedirect(myNotiRedPage)

        }
      }
      localStorage.removeItem('notiRedPage')
    }
  }


  // componentDidUpdate(prevProps) {
  //   var self = this;
  //   console.log("prevpros::", prevProps);
  //   console.log("curent::", this.props);
  //   if(this.props && this.props.notiObj){
  //     if (prevProps.notiObj != this.props.notiObj) {
  //       var myNotiRedPage = this.props.notiObj;
  //       setTimeout(function () {
  //         if (myNotiRedPage) {
  //           myNotiRedPage = JSON.parse(myNotiRedPage);
  //           console.log("myNotiRedPage::", myNotiRedPage.page);
  //           if (myNotiRedPage.page == '/layout/chatwindow' || myNotiRedPage.page == '/layout/adminchat') {
  //             if (window.location.hash != "#/layout/peerchat") {
  //               self.getcomponetColor('peerchat')
  //               self.setActiveTab(myNotiRedPage)
  //               self.props.history.push("/layout/peerchat");
  //             }
  //           } else {
  //             console.log("myNotiRedPage2::", myNotiRedPage.page);
  //             if (!window.location.hash.includes(myNotiRedPage.page)) {
  //               self.getcomponetColor(myNotiRedPage.page)
  //               self.setActiveTab(myNotiRedPage)
  //               self.props.history.push(myNotiRedPage.page);
  //             }
  //           }
  //         }
  //       }, 1200);
  //     }
  //   }
  // }

  triggerDeviceBackButton() {
    var that = this;
    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        document.addEventListener("backbutton", function () {
          console.log("test pathname", that.props.history.location.pathname)
          switch (that.props.history.location.pathname) {
            case '/layout':
              swal({
                title: "",
                text: "Do you want to exit the application",
                icon: "warning",
                buttons: true,
                dangerMode: true,
              })
                .then((willDelete) => {
                  if (willDelete) {
                    if (navigator.app) {
                      navigator.app.exitApp();
                    } else if (navigator.device) {
                      navigator.device.exitApp();
                    } else {
                      window.close();
                    }
                  } else {
                    //  console.log('hi') 
                  }
                });

              break;
            case '/layout/knowyourrights':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            case '/layout/getknowledgeable':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            case '/layout/information':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            case '/layout/nearme':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            case '/layout/peerchat':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            case '/layout/services':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            case '/layout/settings':
              that.props.history.push("/layout");
              // localStorage.setItem('BotInnit', "true");
              break;
            default:
              that.props.history.goBack();
              break;
            // }
          }
        }, false);
      })
    }
  }

  triggerNotiBackButton() {
    var that = this;
    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        // Foreground Local notification clicked
        window.cordova.plugins.notification.local.on("click", function (notification) {
          console.log("forgran2 layoutpage3: ", window.location.hash, notification)
          if (notification.page == '/layout/chatwindow' || notification.page == '/layout/adminchat') {
            if (window.location.hash != "#/layout/peerchat") {
              that.getcomponetColor('peerchat')
              that.setActiveTab(notification)
              //that.props.history.push("/layout/peerchat");
              that.notificationRedirectPeerchat(notification)
            }
          } else {
            console.log("myNotiRedPage2::", notification.page);
            if (!window.location.hash.includes(notification.page)) {
              that.getcomponetColor(notification.page)
              that.setActiveTab(notification)
              that.notificationRedirect(notification)
            }
          }
        });
      })
    }
  }

  notificationRedirectPeerchat(notification) {
    let user = auth().currentUser
    if (!window.location.hash.includes(notification.page)) {
      if (user != null && !window.location.hash.includes('chatwindow') && notification.senderObj) {
        let senderObj = JSON.parse(notification.senderObj)
        this.props.history.push({
          pathname: "/layout/chatwindow",
          state: {
            applicant: { id: senderObj.id, fcmId: senderObj.fcmId, title: notification.title },
            userObj: user,
            chatType: "peer",
          }
        });
      } else if (user != null && !window.location.hash.includes('chatwindow') && notification.applicant && notification.chatType == "group") {
        let grpObj = JSON.parse(notification.applicant)
        this.props.history.push({
          pathname: "/layout/chatwindow",
          state: {
            applicant: { id: grpObj.id, title: notification.title, groupName: notification.title },
            userObj: user,
            chatType: "group",
          }
        });
      } else {
        this.props.history.push("/layout/peerchat");
      }
    }
  }

  notificationRedirect(notification) {
    let user = auth().currentUser
    if (!window.location.hash.includes(notification.page)) {
      if (notification.page == '/layout/services' && user != null && notification.chatType == 'peer' && !window.location.hash.includes('ServicesChatWindow')) {
        this.props.history.push({
          pathname: "/layout/ServicesChatWindow",
          state: {
            caseObj: { caseId: notification.caseId, chatType: "peer", userId: JSON.parse(localStorage.getItem("obj")).userId },
            userObj: user,
            chatType: 'peer'
          }
        });
      } else {
        this.props.history.push(notification.page);
      }
    }
  }

  setActiveTab(obj) {
    console.log('activeTanchech:', obj)
    if (obj.page.includes('services')) {
      sessionStorage.setItem('activeTab', JSON.stringify({ 'service': 1 }))
    } else if (obj.page.includes('peerchat') || obj.page.includes('chatwindow')) {
      if (obj.chatType == 'peer') {
        sessionStorage.setItem('activeTab', JSON.stringify({ 'chat': 1 }))
      }
    }
  }


  getcomponetColor(linkpath) {
    var menulist = JSON.parse(localStorage.getItem("menuList"));
    if (menulist) {
      var obj = menulist.filter(obj => linkpath.includes(obj.path));
      if (obj.length > 0) {
        let bgcolor = obj[0].layout.componentbgcolor
        localStorage.setItem('componentbgcolor', bgcolor)
        //this.props.setcomponentbgcolor(bgcolor)
      }
    }
  }


  render() {
    return (
      <>
        { JSON.parse(localStorage.getItem("obj")).roleType=='Admin' ? (
        window.location.hash != '#/layout/userlogin'?
          (<IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            debounce={250}
            timeout={this.state.timeout} />):
            (null)):
            (null)
        }
        {
          window.location.hash === '#/layout' || window.location.hash === '#/layout/' ?
            <Switch><Route path="/" component={Home} /></Switch> :
            <>
              <div className="fullpage">
                <Header />
                <Grid container spacing={0} className="gridcontainer">
                  <Grid item xs={12}>
                    <Switch>
                      {this.state.aMenuRoutes}
                    </Switch>
                  </Grid>
                </Grid>
                <Bottomnav />
              </div>
            </>
        }

      </>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor,
    notiObj: storeState.notiObj
  };
};

const transLayout = withTranslation()(Layout);
const MyLayout = withRouter(transLayout);

export default connect(mapStateToProps, {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
})(MyLayout);
